import React from 'react'
import { string, bool, element } from 'prop-types'
import { Button } from '@livechat/design-system-react-components'

import auth from '@/utils/auth'

export const SignInButton = ({
  icon,
  size,
  className,
  fullWidth,
  label = 'Get',
}) => (
  <Button
    data-test="install-btn"
    icon={icon || ''}
    size={size}
    onClick={() => auth.signIn()}
    className={className}
    fullWidth={fullWidth}
    kind="primary"
  >
    {label}
  </Button>
)

SignInButton.propTypes = {
  className: string,
  icon: element,
  size: string,
  disabled: bool,
  fullWidth: bool,
  label: string,
}

export default SignInButton
